module.exports = __webpack_public_path__ + "static/media/flame.bff28b8e.svg";